module.exports = __webpack_public_path__ + "prod/1.42.2/img/foot-bj.ae8e34b2.png";